export default function () {
	const heroButton = document.querySelector('.js-hero-button');

	if (heroButton) {
		const heroSVG = heroButton.querySelector('svg');

		function setCustomProperties() {
			heroButton.style.setProperty(
				'--svg-height',
				`-${heroSVG.getBoundingClientRect().height / 2}px`
			);
			heroButton.style.setProperty(
				'--button-height',
				`${heroButton.getBoundingClientRect().height / 2}px`
			);
		}

		setCustomProperties();
		window.addEventListener('resize', setCustomProperties);
	}
}
